import axios from 'axios';
import { BASE, getHeaders } from './config';

export function getMalfactionSummaryReport() {
    return axios.get(`${BASE}/reports/malfactions/summary`, { headers: getHeaders() });
}

export function getMalfactionsReportByTruckType(query) {
    return axios.get(`${BASE}/reports/malfactions/by-truck-type`, { headers: getHeaders(), params: query });
}

export function getMalfactionsReportByTruck(query) {
    return axios.get(`${BASE}/reports/malfactions/by-truck`, { headers: getHeaders(), params: query });
}

export function getMalfactionsReportByTruckDetails(query) {
    return axios.get(`${BASE}/reports/malfactions/by-truck-details`, { headers: getHeaders(), params: query });
}
export function getTrucks() {
    return axios.get(`${BASE}/trucks`, { headers: getHeaders()})
}
export function getTruckByid(id) {
    return axios.get(`${BASE}/reports/malfactions/by-truck-all?plate_number=${id}`, { headers: getHeaders()})
}

export function maintenanceReport(params) {
    return axios.get(`${BASE}/reports/maintenance-report`, { headers: getHeaders(), params })
}